module.exports = __webpack_public_path__ + "img/showcase-icon3.aec7451c.png";